import { useState, useContext } from "react";
import { Alert, Button, TextField } from "@mui/material";
import AppContext from "../../contexts/AppContext";
import { useParams } from "react-router-dom";
import apiFetch from "../../helperFunctions/api";
import useAsyncAction from "../../helperFunctions/useAsyncAction";

export default function AddCharacter({ character: initial = "", setSessionData }) {
  const { API, getCharacters } = useContext(AppContext);
  const [character, setCharacter] = useState(initial);
  const { pending, error, run } = useAsyncAction();
  const { id } = useParams();
  return (
    <>
      {error && <Alert severity="error">{error}</Alert>}
      <TextField value={character} disabled={pending} required onChange={(e) => setCharacter(e.target.value)}
        variant="outlined" label="Add Character to Session" />
      <Button disabled={pending || !character.trim()} variant="outlined" onClick={() => run(async () => {
        const response = await apiFetch(`${API}/session/${id}`, {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ character, action: "ADD_CHARACTER" }),
        });
        setSessionData(await response.json());
        setCharacter("");
        getCharacters();
      })}>{pending ? "Adding..." : "Add Character"}</Button>
    </>
  );
}
